import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'readablebytes'
})
export class ReadablebytesPipe implements PipeTransform {

  transform(bytes: number): string {
    if (bytes === 0) {
      return '0 Bytes';
    }

    let i = Math.floor(Math.log(bytes) / Math.log(1024)),
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    return parseFloat((bytes / Math.pow(1024, i)).toFixed(1)) + ' ' + sizes[i];
  }
}
